import cn from 'classnames'

import { useTab } from '@components/Tabs/Tabs'
import { TabModeEnum } from '../interface'

interface TabListProps {
  className?: string
  borderBottomClassName?: string
  id?: string
  children: React.ReactNode
  isFirstTabMargin: boolean
}

export const TabList = ({
  className,
  borderBottomClassName,
  id,
  children,
  isFirstTabMargin,
}: TabListProps) => {
  const { mode } = useTab()

  return (
    <div
      id={id}
      className={cn(
        'select-none overflow-x-scroll scrollbar-none scrollbar-none::-webkit-scrollbar mb-[20px]',
        className,
        { 'ml-[20px] ': isFirstTabMargin }
      )}
    >
      <div
        className={cn(
          'text-[14px] text-secondary dark:text-dark-10 font-light flex',
          {
            'mobile:ml-[0px] space-x-[15px]': mode === TabModeEnum.BOX,
          }
        )}
      >
        {children}
      </div>
      <div
        className={cn(
          'absolute w-full h-[1px] bottom-[1px] bg-gray-3 dark:bg-purple z-0',
          {
            hidden: mode === TabModeEnum.BOX,
          },
          borderBottomClassName
        )}
      />
    </div>
  )
}
